<div class="main-container lg-view">
  <h3>This Procedure Summary Review link has Expired</h3>
  <div class="refresh-link-container">
	<ng-container *ngIf="isLinkRefreshSuccess">
	  <h4>A new confirmation link has been sent.</h4>
	  <h4>Please check your email for the refreshed link.</h4>
	</ng-container>
	<ng-container *ngIf="!isLinkRefreshSuccess && !isLinkRefreshError">
	  <h4>Please request a new link to continue</h4>
	  <button mat-raised-button (click)="refreshLink()" [disabled]="isLinkRefreshLoading">
	    <span *ngIf="!isLinkRefreshLoading">Refresh Link</span>
	    <span *ngIf="isLinkRefreshLoading">Refreshing...</span>
	  </button>
	</ng-container>
	<ng-container *ngIf="isLinkRefreshError">
	  <h4>Unable to refresh the link. Please try again.</h4>
	  <button mat-raised-button (click)="refreshLink()" [disabled]="isLinkRefreshLoading">
	    <span *ngIf="!isLinkRefreshLoading">Retry</span>
	    <span *ngIf="isLinkRefreshLoading">Refreshing...</span>
	  </button>
	</ng-container>
  </div>
</div>